import { render, staticRenderFns } from "./form_personal_info.vue?vue&type=template&id=28b2c3fe&scoped=true"
import script from "./form_personal_info.vue?vue&type=script&lang=js"
export * from "./form_personal_info.vue?vue&type=script&lang=js"
import style0 from "./form_personal_info.vue?vue&type=style&index=0&id=28b2c3fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b2c3fe",
  null
  
)

export default component.exports